import * as Sentry from '@sentry/react';
import { User } from 'models/User';
import { useEffect } from 'react';
import { getEnabledShippingTypes } from 'redux/slices/enabled-shipping-types/enabled-shipping-types.actions';
import { getPackageProviders } from 'redux/slices/package-providers/package-providers.actions';
import { getPlanLimitsCountThunk } from 'redux/slices/plan-limits-counter';
import {
    getShopifyAppPlans,
    getShopifyAppSubscription,
} from 'redux/slices/shopify-app-pricing/shopify-app-pricing.actions';
import { getThirdPartyFulfillmentSettings } from 'redux/slices/third-party-fulfillment-settings/third-party-fulfillment-settings.actions';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { billingThunk } from '../redux/slices/billing-slice';
import { ecomThunk } from '../redux/slices/ecoms-slice';
import { settingsThunk } from '../redux/slices/settings-slice';
import { wizardThunk } from '../redux/slices/wizard-slice';
import ErrorService from '../services/ErrorService';
import { QueryUtils } from '../utils/queryUtils-keep';
import useBootstrapIntercomData from './intercom/useBootstrapIntercomData';
import usePlanLimits from './plan/usePlanLimits';
import { preloadScopes } from './useScopes';
import { preloadShopData } from './useShopData';
import { useUserData } from './useUserData';

const useBootstrap = () => {
    const dispatch = useAppDispatch();
    const ecoms = useAppSelector((state) => state.ecoms);
    const settings = useAppSelector((state) => state.settings);
    const { hasIntercomSupport } = usePlanLimits();
    useBootstrapIntercomData();

    const { data: userData } = useUserData();

    const setSentryUser = (userData: User) => {
        Sentry.setUser({
            email: userData.email,
            id: userData.id.toString(),
            username: userData.name,
        });
    };

    useEffect(() => {
        if (!userData) {
            // shutdown();
            return;
        }
        setSentryUser(userData);
    }, [userData, hasIntercomSupport]);

    useEffect(() => {}, []);

    const fetch = async () => {
        try {
            if (!ecoms.selected) {
                await dispatch(ecomThunk()).unwrap();
            }
            dispatch(getEnabledShippingTypes());
            dispatch(getPackageProviders());
            QueryUtils.prefetchQueries();
            if (!settings?.settings) {
                dispatch(settingsThunk({}));
            }
            dispatch(getShopifyAppSubscription());
            preloadShopData().catch(() => null);
            preloadScopes().catch(() => null);
            dispatch(getThirdPartyFulfillmentSettings());
            dispatch(getShopifyAppPlans());
            dispatch(wizardThunk());
            dispatch(billingThunk());
            dispatch(getPlanLimitsCountThunk());
        } catch (e) {
            console.log(e);
            ErrorService.redirectToErrorPage();
        }
    };

    return { fetch };
};

export default useBootstrap;
